// Tiny module-level cache for stale-while-revalidate hook state.
// Each scope (table/resource name) gets its own Map keyed by an
// identifier — typically user.id, or `${user.id}:${resourceId}` for
// single-resource hooks like useExercise(id).
//
// Tab switches unmount/remount tab content. Without a cache, each
// remount starts from empty state and shows a skeleton. With this
// cache, the hook hydrates state instantly from the last-known value
// and refetches in the background, eliminating the flash.
//
// No TTL — entries live for the app's lifetime. Per-user keying means
// signing out and back in as a different user gets a fresh fetch.
const stores = new Map()

export function getCached(scope, key) {
  if (!key) return undefined
  return stores.get(scope)?.get(key)
}

export function setCached(scope, key, value) {
  if (!key) return
  if (!stores.has(scope)) stores.set(scope, new Map())
  stores.get(scope).set(key, value)
}

export function clearCached(scope, key) {
  if (!key) return
  stores.get(scope)?.delete(key)
}

export function clearScope(scope) {
  stores.delete(scope)
}
